// src/features/bookings/components/BookingDetail/tabs/BookingWorkflowTab.jsx
import React from 'react';
import DeliverablesTable from '../DeliverablesTable';

const BookingWorkflowTab = ({ booking, onDataChange }) => (
  <DeliverablesTable
    bookingId={booking.id}
    deliverables={booking.deliverables ?? []}
    onDataChange={onDataChange}
  />
);

export default BookingWorkflowTab;